export default __webpack_public_path__ + "9d2eb3c77ff6e22d4023a7190775f634.svg";